import React, { useRef, useEffect, useState, useCallback } from 'react';
import { Tooltip } from '@mui/material';

export interface ElipsisTextProps {
  text: string;
  node?: React.ReactNode;
  className?: string;
  width: string;
  onClick?: (e?: any) => void;
  alwaysShowTooltip?: boolean;
}

const ElipsisText: React.FC<ElipsisTextProps> = ({ node, text, className, width, onClick, alwaysShowTooltip }) => {
  const textElementRef = useRef(null);
  const [hoverStatus, setHover] = useState(false);

  const compareSize = useCallback(() => {
    // @ts-ignore
    const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
    setHover(compare);
  }, [setHover, textElementRef]);

  useEffect(() => {
    compareSize();
  }, [text, compareSize]);

  return (
    <Tooltip
      title={text}
      arrow
      disableHoverListener={!alwaysShowTooltip && !hoverStatus}
      classes={{
        tooltip: 'tooltip',
      }}
    >
      <div
        className={`elipsis ${className}`}
        ref={textElementRef}
        style={{ maxWidth: width }}
        onClick={onClick}
      >
        {node || text}
      </div>
    </Tooltip>
  );
};

export default ElipsisText;
